import { parseISO } from 'date-fns';
import { InvalidQueryParams } from 'src/utils/errors';

export function isValidDate(value: string | Date) {
  const date = typeof value === 'string' ? parseISO(value) : value;
  const invalid = date instanceof Date && isNaN(date.getTime());
  return !invalid;
}

export function isValidDateString(value: unknown): value is string {
  return typeof value === 'string' && isValidDate(value);
}
export function isValidDateQuery(value: unknown, name: string) {
  if (isValidDateString(value)) return value;
  throw new InvalidQueryParams({ name, value });
}
